import './contact.less'

import {Form, Formik} from 'formik'
import requestService from 'mithril/request/request'
import React, {HTMLProps, useContext, useState} from 'react'
import {WysiwygType} from 'types'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {FormField} from 'views/form/form'
import {PopupModal} from 'views/layout/popupmodal'
import {Theme} from 'views/theme'
import {EntryContext} from '../../util/entrycontext'

const request = requestService(window, Promise).request

const styles = style('contact', ['form'])

export type ContactType = {
	agreement?: WysiwygType
	thanks_title?: string
	thanks_text?: WysiwygType
}

type ContactFormData = {
	firstname?: string
	lastname?: string
	email?: string
	message?: string
}

export const Contact: React.FC<HTMLProps<HTMLDivElement> & ContactType> = ({
	agreement,
	thanks_title,
	thanks_text
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<ContactForm
						agreement={agreement}
						thanks_title={thanks_title}
						thanks_text={thanks_text}
					/>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const ContactForm: React.FC<{
	agreement?: WysiwygType
	thanks_title?: string
	thanks_text?: WysiwygType
}> = ({agreement, thanks_title, thanks_text}) => {
	const [isSubmitted, setSubmitted] = useState(false)
	const {id} = useContext(EntryContext)

	return (
		<Formik<ContactFormData>
			initialValues={{}}
			onSubmit={(values, {setErrors, resetForm}) =>
				request({
					method: 'POST',
					url: `/api/contact/${id}`,
					data: values
				})
					.then(response => {
						resetForm()
						setSubmitted(true)
					})
					.catch(error => {
						setErrors(JSON.parse(error.message))
					})
			}
		>
			<div className={styles.form()}>
				<Form id="contact_form">
					<div className={styles.form('row')}>
						<div className={styles.form('left')}>
							<FormField
								required
								name="firstname"
								label={t('contact.firstname')}
								mod="background"
							/>
							<FormField
								required
								name="lastname"
								label={t('contact.lastname')}
								mod="background"
							/>
							<FormField
								required
								type="email"
								name="email"
								label={t('contact.email')}
								mod="background"
							/>
						</div>
						<div className={styles.form('right')}>
							<FormField
								required
								component="textarea"
								name="message"
								label={t('contact.message')}
								mod="background"
							/>
						</div>
					</div>
					<FormField
						required
						type="checkbox"
						name="agree"
						label={
							<Theme.Wysiwyg mod="inherit">
								{agreement || t('subscribe.agreement')}
							</Theme.Wysiwyg>
						}
						mod="small"
					/>
					<div className={styles.form('button')}>
						<Theme.Button
							as="button"
							type="submit"
							mod={['arrowlong', 'white']}
						>
							<Theme.ButtonText>{t('contact.submit')}</Theme.ButtonText>
							<Theme.ButtonIcon icon="arrow-long" />
						</Theme.Button>
					</div>
				</Form>
				<PopupModal
					open={isSubmitted}
					onClose={() => {
						setSubmitted(false)
					}}
				>
					<PopupModal.Block>
						<PopupModal.Content mod="big">
							<Theme.H1 as="h2" mod={['dots']}>
								{thanks_title || t('subscribe.thanks.title')}
							</Theme.H1>
							<PopupModal.Message>
								<Theme.Wysiwyg>
									{thanks_text || t('subscribe.thanks.text')}
								</Theme.Wysiwyg>
							</PopupModal.Message>
						</PopupModal.Content>
						<PopupModal.Footer />
					</PopupModal.Block>
				</PopupModal>
			</div>
		</Formik>
	)
}
